import { render, staticRenderFns } from "./BusCard.vue?vue&type=template&id=5b878994&scoped=true&"
import script from "./BusCard.vue?vue&type=script&lang=js&"
export * from "./BusCard.vue?vue&type=script&lang=js&"
import style0 from "./BusCard.vue?vue&type=style&index=0&id=5b878994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b878994",
  null
  
)

export default component.exports